<template>
    <form class="space-y-5" @submit.prevent>
        <slot name="fields" />
        <div class="flex justify-end gap-3">
            <slot name="buttons" />
        </div>
    </form>
</template>
